import styled from "styled-components";

const HeaderBottom = styled.div``;

export default HeaderBottom;